import { Scenario } from "../data/scenarios";

interface Props {
  scenario: Scenario;
}

export const ScenarioCard = ({ scenario }: Props) => (
  <article className="flex w-[293px] shrink-0 flex-col items-stretch gap-8 rounded-[40px] bg-white px-4 pb-8 pt-4 shadow-[0_6px_16px_0_rgba(3,3,26,0.08),0_0_10px_0_rgba(100,100,100,0.08)]">
    <div className="h-[192px] overflow-hidden rounded-[28px] bg-[#FFF6CC]">
      <img
        src={scenario.imageUrl}
        alt={scenario.title}
        className="h-full w-full object-cover"
      />
    </div>

    <div className="flex flex-col gap-3 px-2">
      <div className="flex flex-col gap-2">
        <span
          aria-hidden
          className="inline-flex h-10 w-10 items-center justify-center rounded-[10px] bg-[#FFF6CC]"
        >
          <img src={scenario.iconUrl} alt="" className="h-[30px] w-[30px]" />
        </span>
        <h3 className="text-[19px] font-bold leading-[1.2] text-[#0D0D0D]">
          {scenario.title}
        </h3>
      </div>
      <p className="text-[13px] leading-[1.6] tracking-[0.26px] text-[#0D0D0D]">
        {scenario.description}
      </p>
    </div>
  </article>
);
